const actions = {
  getDate({ commit }) {
    commit("GET_DATE");
  },

  setDate({ commit }, date) {
    commit("SET_DATE", date);
  },

  getToken({ commit }) {
    commit("GET_TOKEN");
  },

  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },

  getNota({ commit }) {
    commit("GET_NOTA");
  },

  setNota({ commit }, nota) {
    commit("SET_NOTA", nota);
  },

  getProdutos({ commit }) {
    commit("GET_PRODUTOS");
  },

  setProdutos({ commit }, produtos) {
    commit("SET_PRODUTOS", produtos);
  },

  getBeneficio({ commit }) {
    commit("GET_BENEFICIO");
  },

  setBeneficio({ commit }, beneficio) {
    commit("SET_BENEFICIO", beneficio);
  },
};

export default actions;
